import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AsyncErrorHandler } from 'lib/ui';
import { CheckDuplicatePenPipeSDR, PenPipeSDRDto } from 'models/pen/PenPipeSDR';
import { ErrorService } from 'services/error-service';
import { PenPipeSDRService } from 'services/pen/pen-pipe-SDR-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class PenPipeSdrDetail {
  private penPipeSdrDto: PenPipeSDRDto;
  protected checkDuplicateData: CheckDuplicatePenPipeSDR = new CheckDuplicatePenPipeSDR();

  private constructor(
    private penPipeSDRService: PenPipeSDRService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator,
    private toastService: ToastService,
    private router: Router
  ) {}

  protected async activate(params: { Id: string }) {
    try {
      this.penPipeSdrDto = await this.penPipeSDRService.get(params.Id);
    } catch (error) {
      this.errorService.handleError(error);
    }
  }

  @AsyncErrorHandler
  async updatePenPipeSDR() {
    if (await this.checkDuplicate()) return;

    this.penPipeSdrDto.Name = this.penPipeSdrDto.SDR.toString();
    await this.penPipeSDRService.put(this.penPipeSdrDto, this.penPipeSdrDto.Id);
    this.eventAggregator.publish('penPipeSDRsReset', 1);
    this.toastService.showSuccess('pens.penPipeSDRUpdated');
    this.router.navigateToRoute('pen-pipe-sdr-list');
  }

  protected gotoParentView() {
    this.eventAggregator.publish('penPipeSDRsReset', 1);
    this.router.navigateToRoute('pen-pipe-sdr-list');
  }

  protected async checkDuplicate() {
    this.checkDuplicateData.Id = this.penPipeSdrDto.Id;
    this.checkDuplicateData.SDR = this.penPipeSdrDto.SDR;
    const { IsDuplicate } = await this.penPipeSDRService.checkDuplicate(this.checkDuplicateData);
    this.eventAggregator.publish('penPipeSDRIsDuplicate', IsDuplicate);
    return IsDuplicate;
  }
}
